import { age_order, salary_age_order } from '../dictionaries/charts_orders.js';

export const formatChartData = (
  data,
  order,
  orderProperty,
  property,
  splitProp = ''
) => {
  if (!data) return [];
  if (!splitProp) {
    return data
      .sort((a, b) => {
        return (
          order.indexOf(a[orderProperty]) - order.indexOf(b[orderProperty])
        );
      })
      .map((item) => item[property]);
  }
  const uniqueValues = [...new Set(data.map((item) => item[splitProp]))];
  const result = {};
  uniqueValues.forEach((value) => {
    result[value] = data
      .filter((item) => item[splitProp] === value)
      .sort((a, b) => {
        return (
          order.indexOf(a[orderProperty]) - order.indexOf(b[orderProperty])
        );
      })
      .map((item) => item[property]);
  });
  return result;
};

export const formatChartSalary = (data) => {
  return Object.keys(data).map((item) => {
    return {
      name: item,
      data: Object.keys(data[item])
        .sort((a, b) => {
          return salary_age_order.indexOf(a) - salary_age_order.indexOf(b);
        })
        .map((age) => {
          return data[item][age].salary;
        }),
    };
  });
};

export const formatChartEmployment = (data, prop) => {
  const ages = [
    '15',
    '16_24',
    '25_28',
    '29_34',
    '35_44',
    '45_54',
    '55_64',
    '65_plus',
  ];

  return [
    {
      name: 'Мужчины',
      data: ages.map((item) => data[`${prop}_${item}_men`]),
    },
    {
      name: 'Женщины',
      data: ages.map((item) => data[`${prop}_${item}_women`]),
    },
  ];
};

export const formatPopulationByAgeData = (data) => {
  const categories = ['Мужчины', 'Женщины'];

  return categories.map((item) => {
    return {
      name: item,
      data: data
        .sort((a, b) => {
          return (
            age_order.indexOf(a.age_bucket) - age_order.indexOf(b.age_bucket)
          );
        })
        .map(
          (elem) => elem[`${item === 'Мужчины' ? 'male' : 'female'}_population`]
        ),
    };
  });
};
